export const HOME = '/';
export const ACCOUNT = '/account';
export const CART = '/cart';
export const ADMIN_PRODUCTS = '/admin/products';
export const SIGNIN = '/signin';
export const SIGNOUT = '/signout';
export const SIGNUP = '/signup';
export const SEARCH = '/search';
export const PRODUCTS='/productSearch';
export const DETAILS='/productDetails';
export const COMPARE='/productCompare';
export const ORDERHISTORY = '/orderhistory';
export const ORDERHISTORYDETAIL = '/orderhistory/:ordernumber';
export const ORDERHISTORYDETAILLINE = '/orderhistory/:ordernumber/:linenumber';
export const THANKYOU = '/thankYou/*';
export const RECENTPURCHASE = '/recentPurchase';
export const ORDERRECEIPT = '/orderReceipt';
export const TRANSACTIONS = '/transactions';
export const CHANGECUSTOMER = '/changeCustomer';
export const PAYMENT = '/payment';
export const QUOTATION = '/quotation';
export const QUOTATIONDETAIL = '/quotation/quotationdetail' //'/quotation/:quotationnumber/:versionnumber/:type';
export const QUOTATIONDETAILLINE = '/quotation/quotationdetail/quotationdetailline';
export const BESTOFFER = "/bestOffer";
export const MOSTPOPULAR = "/mostPopular";
export const CATALOG='/catalog';
export const SHOPPINGLISTS = '/shoppingLists'
export const DEFAULTSHOPPINGLISTS = SHOPPINGLISTS + '/listDetails'
export const LISTDETAILS = SHOPPINGLISTS + '/listDetails/:listid'
export const INVOICE = '/invoice';
export const ACCOUNTSETTINGS = '/accountSettings'
export const INVOICEDETAIL = '/invoice/invoicedetail'
export const INVOICEDETAILLINE = '/invoice/invoicedetail/invoicedetailline';
export const CONTACTUS = '/contactUs'
export const REQUESTSUBMIT = '/requestsubmit'
export const REQUESTRECEIVED = REQUESTSUBMIT + '/requestReceived'
export const REQUEST = '/request'
export const REQUESTHISTORYDETAIL = '/request/:requestnumber';
export const REQUESTHISTORYDETAILLINE = '/request/:requestnumber/:linenumber';